import Handlebars from 'handlebars';

const NS = 'WoolBtbRecentIssuesBlock';
const CLS = 'woolBtbRecentIssuesBlock';

export class WoolBtbRecentIssuesBlock {
	constructor(element) {
		this.element = element;
		this.$el = $(element);

		this.$issues = this.$el.find(`.${CLS}-issues`);
		this.$categoryDropdown = this.$el.find(`select.${CLS}-control-category`);
		this.getIssuesApi = this.$el.data('issuesApi');

		this.initParams();
		this.eventHandler();

		$.ajax({
			type: 'GET',
			url: `${this.getIssuesApi}`,
			success: (data) => {
				if(data.results.length == 0){
					$(".woolBtbRecentIssuesBlock").css("display", "none");
				}
			},
			error: (res, error) => {
				console.log("error loading articles", error);
			},
		});	
		
		this.getArticles();
	}

	initParams(){
		this.params = {
			pageID: this.sourceID,
			category: this.$categoryDropdown.val()
		};
	}

	eventHandler() {

		this.$categoryDropdown.on('change', () => {
			this.$issues.empty();
			this.params.category = this.$categoryDropdown.val();
			this.getArticles(false);
		});
	}
	
	getArticleCardBlockTemplate() {
		let woolBtbRecentIssueBlock = require('../../woolBtbRecentIssueBlock/tmpl/woolBtbRecentIssueBlock.hbs');
		Handlebars.registerPartial('woolBtbRecentIssueBlock', woolBtbRecentIssueBlock);

		let template = `
			{{> woolBtbRecentIssueBlock
				wg="woolBtbRecentIssueBlock"
			}}
		`;

		let precompiled = new Function('return ' + Handlebars.precompile(template))();
		return Handlebars.template(precompiled);
	}

	getArticles() {
		let url = `${this.getIssuesApi}?year=${this.params.category}`;
		$.ajax({
			type: 'GET',
			url: url,
			success: (data) => {

				data.results.forEach((item) => {
					item["wg"] = "woolBtbRecentIssueBlock";
					this.$issues.append(this.getArticleCardBlockTemplate()(item));
				});
			},
			error: (res, error) => {
				console.log("error loading articles", error);
			},
			complete: () => {

			},
		});	
	}
}
